/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { notificationBatchAdminControllerSearchV1 } from '../fn/notification-batch-admin/notification-batch-admin-controller-search-v-1';
import { NotificationBatchAdminControllerSearchV1$Params } from '../fn/notification-batch-admin/notification-batch-admin-controller-search-v-1';
import { NotificationBatchDto } from '../models/notification-batch-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class NotificationBatchAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `notificationBatchAdminControllerSearchV1()` */
  static readonly NotificationBatchAdminControllerSearchV1Path = '/api/v1/notification-batches/admin/search';

  /**
   * 알림 발송 내역 검색 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationBatchAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationBatchAdminControllerSearchV1$Response(params: NotificationBatchAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<NotificationBatchDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = notificationBatchAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 알림 발송 내역 검색 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationBatchAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationBatchAdminControllerSearchV1(params: NotificationBatchAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<NotificationBatchDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.notificationBatchAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<NotificationBatchDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<NotificationBatchDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

}
